import { render, staticRenderFns } from "./DealDetailsModal.vue?vue&type=template&id=024e4ed9&"
import script from "./DealDetailsModal.vue?vue&type=script&lang=js&"
export * from "./DealDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./DealDetailsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports